import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const SourceModal = ({ onClose, addSource }) => {
  const [newSource, setNewSource] = useState("");
  const api_url = process.env.REACT_APP_API_URL;

  const handleAddSource = () => {
    if (newSource.trim() !== "") {
      axios
        .post(`${api_url}/api/source`, { SourceName: newSource })
        .then((response) => {
          if (response.status === 201) {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Source added successfully.",
            }).then(() => {
              addSource(newSource); // Ensure this line works correctly
              setNewSource(""); // Clear the input
              onClose(); // Close the modal
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Error adding source. Please try again.",
          });
          console.error("Error adding source:", error);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter a source name!",
      });
    }
  };

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="custom-modal-header">
          <h5 className="custom-modal-title">Add New Source</h5>
          <button className="btn-close" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div className="custom-modal-body">
          <input
            type="text"
            className="form-control"
            placeholder="Enter new source"
            value={newSource}
            onChange={(e) => setNewSource(e.target.value)}
          />
        </div>

        {/* Modal Footer */}
        <div className="custom-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={handleAddSource}>
            Add Source
          </button>
        </div>
      </div>
    </div>
  );
};

export default SourceModal;
